import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
	PiChatChattingSolid,
	PiChatChattingStroke,
	PiNotebookSolid,
	PiNotebookStroke,
	focusVisible,
	tokens,
} from '@treams/treams-ui';

import Logomark from './treams-logomark.svg?react';

const Button = styled.button<{ $open: boolean }>`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	padding: 0;
	border-radius: ${tokens.radius.full}px;
	cursor: pointer;
	flex-shrink: 0;
	background: ${(props) => (props.$open ? tokens.surface.sidebar : tokens.surface.white)};
	border: 1px solid ${(props) => (props.$open ? tokens.border.focus : tokens.border.default)};

	${focusVisible}
`;

function RailButton(props: {
	open: boolean;
	label: string;
	onClick: () => void;
	children: ReactNode;
}) {
	return (
		<Button
			type="button"
			$open={props.open}
			aria-pressed={props.open}
			aria-label={props.label}
			onClick={props.onClick}
		>
			{props.children}
		</Button>
	);
}

export function TreamsAIToggle(props: { open: boolean; onClick: () => void }) {
	const { t } = useTranslation();

	return (
		<RailButton open={props.open} label={t('sidebar.aiAgent')} onClick={props.onClick}>
			<Logomark />
		</RailButton>
	);
}

export function ContextSidebarToggle(props: { open: boolean; onClick: () => void }) {
	const { t } = useTranslation();
	const Icon = props.open ? PiNotebookSolid : PiNotebookStroke;

	return (
		<RailButton
			open={props.open}
			label={t('conversation.sidebar.context.openButton.title')}
			onClick={props.onClick}
		>
			<Icon size={20} color={props.open ? tokens.text.inverse : tokens.icon.primary} aria-hidden />
		</RailButton>
	);
}

export function HelpdeskToggle(props: { open: boolean; onClick: () => void }) {
	const { t } = useTranslation();
	const Icon = props.open ? PiChatChattingSolid : PiChatChattingStroke;

	return (
		<RailButton open={props.open} label={t('sidebar.helpdesk')} onClick={props.onClick}>
			<Icon size={20} color={props.open ? tokens.text.inverse : tokens.icon.primary} aria-hidden />
		</RailButton>
	);
}
